import * as React from 'react';

import FontAwesome from 'components/FontAwesome';
import CircularGradient, { CircularGradientProps } from './CircularGradient';

export type CircularGradientEnvelopeProps = Pick<
  CircularGradientProps,
  'className'
>;

const CircularGradientEnvelope: React.FC<CircularGradientEnvelopeProps> = ({
  className,
}) => (
  <CircularGradient className={className}>
    <FontAwesome icon="envelope" style={{ height: '44%', width: '44%' }} />
  </CircularGradient>
);

export default CircularGradientEnvelope;
